import React from 'react';
// import Switch from '@material-ui/core/Switch';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Container } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 180,
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
}));

export default function History({ parent }) {
    const classes = useStyles();
    const [checked, setChecked] = React.useState(false);
    const [elevation, setElevation] = React.useState(0);

    // const handleChange = () => {
    //     setChecked((prev) => !prev);
    // };
    React.useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    return (
        <section id="history">
            <div className="features-bg1">
                <Container>
                    <div className="heading">
                        <Typography variant="h4" className="efecto-espejo">
                            Historia
                        </Typography>
                    </div>
                    <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(4)} onMouseOut={() => setElevation(0)}>
                        <Slide direction="left" in={parent} mountOnEnter unmountOnExit timeout={500}>
                            <Typography paragraph align="justify">
                                La historia de la Meteorología en Santiago tiene su comienzo con mediciones que realizaba del Padre Viña en la Iglesia Dolores en el siglo 19, que solo se concretaban a meras
                                observaciones rudimentarias con tres o cuatro instrumentos construidos artesanalmente. En la antigua provincia de Oriente con su capital en Santiago de Cuba, se estructuró el
                                Centro Meteorológico, con los territorios de las actuales provincias de las Tunas, Holguín, Granma, Guantánamo y Santiago de Cuba, dirigida por una oficina creada en esta última,
                                subordinada técnicamente al INSMET en Casa Blanca y formando parte de la estructura de la Delegación Territorial de la antigua  Academia  de Ciencias en estas provincias
                                orientales.	En el año 1963 queda constituido oficialmente el centro aumentando la red oriental en personal calidad y eficiencia, con la creación de estaciones y algunas
                                heredadas de otros organismos con un total de 18 estaciones en toda la región oriental. El centro en sus inicios se encontraba funcionando en la casa de Salvador Deas,
                                luego es trasladado a la calle Heredia, posteriormente a la casa de Manduley 308 (sede actual de la Delegación del CITMA en Santiago) y luego con la creación de la Academia de
                                Ciencias de Cuba se le sede el local a este último y es reubicado el Centro Meteorológico en el local que hoy ocupa, en Calle 4 esq.17 Vista Alegre.	En el año 1972 la OMM nos
                                brinda su cooperación en técnica, instrumentos y transporte bajo el programa que se llamo "CUBA-7" y es entonces que se comienzan a construir estaciones con las características
                                reglamentadas internacionalmente y se construyen en esta región oriental, incluyendo el radar, con el esfuerzo mancomunado de muchos otros trabajadores de esta región y de la
                                sede nacional.
                            </Typography>
                        </Slide>
                    </Paper>
                  
                </Container>
            </div>
        </section>
    );
}